/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './RoomsView.scss'
import React from 'react'
import { ListItem, Subtitle, Title } from '../../atoms'
import { ListGroup } from '../../molecules'
import Cell from '../../templates/Cell'
import RoomAction from '../../../action/room'
import r from '../../../util/Renderer'
import { NormalButton, NavigationDrawer } from 'ui-library/dist/external/components'

function RoomsView(props) {
  const rooms = props.rooms
  const toolbar = { label: '部屋管理', items: props.accountMenu }

  return (
    <div id="ConfigRooms">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />
      <div className="Rooms">
        <div className="Rooms__List">
          {r.renderIfOrElse(rooms.size > 0)(
            <ListGroup border="underline" className="ItemGroup">
              {rooms.map(room => (
                <ListItem key={room.id} className="Item">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-8 col-lg-8 align-self-center">
                        <Cell className="Item__Name">
                          <Title>{room.name}</Title>
                          <Subtitle>{room.address}</Subtitle>
                        </Cell>
                      </div>
                      <div className="ml-auto col-auto align-self-center">
                        <Cell className="Item__Action">
                          <NormalButton onClick={() => RoomAction.onUpdate(room)}>編集</NormalButton>
                        </Cell>
                      </div>
                    </div>
                  </div>
                </ListItem>
              ))}
            </ListGroup>
          )(
            <div className="row">
              <div className="col-12">
                <div className="Rooms__List--empty">
                  <div className="inner">
                    <div className="message">登録されている宿はありません</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RoomsView
